import request from 'services/request';

export async function CreditNotesMassiveUpload({ cancelToken, data }) {
  let uri = `AccountStatement/Api/v1/CreditNotes/MassLoadExcel`;
  return request(uri, {
    method: 'POST',
    cancelToken,
    data,
  });
}

export async function requestElementsExistence({ cancelToken }) {
  let uri = `/AccountStatement/Api/v1/Statements/ExistsStatements`;
  return request(uri, {
    method: 'GET',
    cancelToken,
  });
}
